var exports = {
  "O": "FavoritesGuildHeader.module__headerIconContainer___TDZJT1",
  "n": "FavoritesGuildHeader.module__headerIcon___TDZJT1",
};

module.exports = exports;
